import React from 'react';
import { Reveal, SectionLabel } from './Section';
import { CAREER_ITEMS, CAREER_TIMELINE } from '../data/content';
import { FileText, Linkedin, Users, Bot, Briefcase, HeartHandshake } from 'lucide-react';

const ICONS = [FileText, Linkedin, Users, Bot, Briefcase, HeartHandshake];

export default function CareerPlacement() {
  return (
    <section id="placement" className="py-24 lg:py-32">
      <div className="max-w-[1400px] mx-auto px-6 lg:px-10">
        <Reveal><SectionLabel>Career Success & Placement Ecosystem</SectionLabel></Reveal>
        <Reveal delay={0.05}>
          <h2 className="font-display text-[42px] sm:text-[56px] lg:text-[68px] leading-[1.02] font-semibold text-[#293891] mt-6 max-w-4xl">
            We don't stop at teaching. <span className="text-[#E63329]">We get you hired.</span>
          </h2>
        </Reveal>
        <Reveal delay={0.1}>
          <p className="mt-6 max-w-3xl text-[15px] leading-relaxed text-[#293891]/75">
            Skills get you in the room — our Career Success ecosystem gets you the offer. Structured placement training includes in-person mock interviews with detailed personalised feedback, plus unlimited AI mock interview practice on PlacementPilot.
          </p>
        </Reveal>

        <div className="grid sm:grid-cols-2 lg:grid-cols-3 gap-4 mt-14">
          {CAREER_ITEMS.map((c,i) => {
            const Icon = ICONS[i];
            return (
              <Reveal key={c.title} delay={i*0.06}>
                <div className="card-lift bg-white border border-[#293891]/10 rounded-3xl p-6 h-full">
                  <div className="w-12 h-12 rounded-2xl flex items-center justify-center text-[#E63329]" style={{background:'rgba(230,51,41,0.08)'}}>
                    <Icon size={20}/>
                  </div>
                  <h3 className="font-display text-[19px] font-semibold text-[#293891] mt-5">{c.title}</h3>
                  <p className="text-[13px] leading-relaxed text-[#293891]/70 mt-3">{c.desc}</p>
                </div>
              </Reveal>
            );
          })}
        </div>

        {/* Timeline */}
        <Reveal delay={0.15}>
          <div className="mt-20">
            <div className="text-[11px] tracking-[0.25em] uppercase font-semibold text-[#293891]/70">How placement works</div>
            <div className="mt-8 relative">
              <div className="absolute top-6 left-0 right-0 h-[2px] bg-gradient-to-r from-[#293891] via-[#E63329] to-[#293891]/20"/>
              <div className="relative grid grid-cols-2 sm:grid-cols-5 gap-6">
                {CAREER_TIMELINE.map((t,i) => (
                  <div key={t.step} className="flex flex-col items-start">
                    <div className={`w-12 h-12 rounded-full flex items-center justify-center text-white font-display font-semibold text-[16px] shadow-lg ${i === CAREER_TIMELINE.length-1 ? 'bg-[#E63329]' : 'bg-[#293891]'}`}>
                      {t.step}
                    </div>
                    <h4 className="mt-5 font-display text-[16px] font-semibold text-[#293891]">{t.title}</h4>
                    <p className="text-[12px] text-[#293891]/60 mt-1">{t.sub}</p>
                  </div>
                ))}
              </div>
            </div>
          </div>
        </Reveal>
      </div>
    </section>
  );
}
